import './ArtVideo.scss';

class ArtVideo {

	constructor(node) {
		this.node = node;
	}

	init() {
		console.log('ArtVideo');
	}

}

if (typeof JSModules === "object") {
	JSModules['ArtVideo'] = ArtVideo;
} else {
	// initialize section
	let section = new ArtVideo;
	section.init();
}

export default ArtVideo;
